<template>
    <span
        v-if="saving"
        class="saving semibold"
        data-qa="saving-status"
    >
        <ds-icon name="loader" class="saving-icon" />

        <span>{{ $t('funnel.saving') }}</span>
    </span>

    <DsStatus
        v-else
        type="good"
        data-qa="save-success"
        emphasis="medium"
    >
        {{ $t('funnel.saved') }}
    </DsStatus>
</template>

<script>
export default {
    props: {
        saving: Boolean,
    },
};
</script>

<style lang="scss" scoped>
.saving {
    display: inline-flex;
    align-items: center;
    color: $color-gray-700;
    --icon-color: #{$color-gray-700};
    --icon-size: 12px;
    font-size: $font-size-xs;
    margin: $spacing-025 0;
}

.saving-icon {
    @include margin-end($spacing-050);
    animation: spin 4s infinite;
}
</style>
